export default __webpack_public_path__ + "static/media/work-light.86eca258.svg";